import firebase from "firebase/compat/app"
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import 'firebase/compat/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyAk8knfp6tbhhqLfhCOA17AIM5GJqlC9IU",
    authDomain: "my-therapy-6765d.firebaseapp.com",
    projectId: "my-therapy-6765d",
    storageBucket: "my-therapy-6765d.appspot.com",
    messagingSenderId: "872245508576",
    appId: "1:872245508576:web:3993ee295c974f74409385"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  export const auth = getAuth(firebaseApp);
  export const storage = getStorage(firebaseApp);
const db = firebaseApp.firestore()

export default db;